import { create } from "zustand";

interface TourStore {
  /** Bumped on every launch request so repeat launches still fire. */
  requestCount: number;
  requestedChapterId: Nullable<string>;
  requestTour: (chapterId?: string) => void;
  reset: () => void;
}

/**
 * Bridges the launcher (in the nav bar) to the tour controller (mounted in
 * Home, where it can observe Redux state).
 */
export const useTourStore = create<TourStore>((set, get) => ({
  requestCount: 0,
  requestedChapterId: null,
  requestTour: (chapterId) =>
    set({ requestCount: get().requestCount + 1, requestedChapterId: chapterId ?? null }),
  reset: () => set({ requestCount: 0, requestedChapterId: null })
}));

export const selectRequestCount = (s: TourStore) => s.requestCount;
export const selectRequestedChapterId = (s: TourStore) => s.requestedChapterId;
export const selectRequestTour = (s: TourStore) => s.requestTour;
